module.exports = __webpack_public_path__ + "img/search.f7042328.png";